import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCirclePlusIconSecondary from './svgs/CirclePlusIconSecondary.js';
import SvgCirclePlusIcon from './svgs/CirclePlusIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var circlePlusIcon = (props => useIcon(SvgCirclePlusIcon, SvgCirclePlusIconSecondary, props));

export { circlePlusIcon as default };
